var m = require('mithril')
var prop = require('mithril/stream');
var columnModal = require('../../data/components/columnModal');
var Draggable = require('../../libs/draggable');
var loaders = require('../../layout/components/loaders');

module.exports = {
  oninit: function (vnode) {
    var ctrl = this;
    ctrl.record = prop(vnode.attrs.dataset);
    ctrl.options = vnode.attrs.options;
    ctrl.columns = Array.isArray(ctrl.record().out_Column) ? ctrl.record().out_Column : [];
    ctrl.columns.sort(function (a,b) {return a.index - b.index});

    ctrl.addColumn = columnModal.editDialogue;

    ctrl.deleteColumn = function (elementIndex) {
      return columnModal.deleteDialogue(ctrl.columns[elementIndex]);
    };

    ctrl.editColumn = function (elementIndex) {
      return columnModal.editDialogue(ctrl.columns[elementIndex], {columnNameRequired: true});
    };

    ctrl.sortChildren = function (columnNodes) {
      var orderedRids = Array.from(columnNodes || [])
        .map(function (node) {
          return node && node.id ? node.id : null;
        })
        .filter(Boolean);

      if (!orderedRids.length) {
        return Promise.resolve();
      }

      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/dataset/' + ctrl.record()['@rid'].slice(1) + '/childorder',
        method: 'PUT',
        body: {
          rids: orderedRids
        }
      })
      .then(vnode.attrs.parentCtrl.init);
    };

    ctrl.addColumnBox = function () {
      return loaders.requestWithLoader({
        loader: 'background',
        url: '/api/v1/dataset/' + ctrl.record()['@rid'].slice(1),
        method: 'GET',
        background: true
      })
      .then(function (datasetRecord) {
        return ctrl.addColumn({out: ctrl.record()['@rid'], path: datasetRecord && datasetRecord.path}, {onlyTree: true, columnNameRequired: true});
      });
    };
  },
  view: function (vnode) {
    var ctrl = this;
    ctrl.record = prop(vnode.attrs.dataset);
    ctrl.columns = Array.isArray(ctrl.record().out_Column) ? ctrl.record().out_Column : [];
    ctrl.columns.sort(function (a,b) {return a.index - b.index})
    return m('thead', [
      m(Draggable, {onsort: ctrl.sortChildren, draggable: '.th-drag', handleClass: '.th-drag-handle', htmlElement: 'tr'}, [
        (ctrl.options && ctrl.options.preColumns) ? ctrl.options.preColumns : [],
        ctrl.columns.map(function (column, idx) {
          var columnName = column.name || column;
          return m('th.br.bb-0.bt-0.bl-0.b--dotted.bw1.fw2.th-drag.ph2.pv2', {id: column['@rid'], key: column['@rid'] || idx}, [
            m('div.ph2', [
              m('p.ma0.mb2.tc', [
                m('span.blue.th-drag-handle.pointer.f3', {
                  style: {cursor: 'grab'},
                  onclick: ctrl.editColumn.bind(null, idx)
                }, columnName)
              ]),
              m('p.ma0.tc', [
                m('i.ion-ios-trash.dib.v-mid.mh2.red.f4', {onclick: ctrl.deleteColumn.bind(null, idx)})
              ])
            ])
          ])
        }),
        m('th.bt-0.bl-0.br-0.bb-0.b--dotted.bw1.ph2.pv2', [
          m('p.tc', m('i.icon.ion-plus.blue.dib.ml2', {onclick: ctrl.addColumnBox}))
        ])
      ])
    ])
  }
}
